// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1nFjO","range":"MonthRangeSwitch_range__325Dn","disabled":"MonthRangeSwitch_disabled__10dKx"};